// extracted by mini-css-extract-plugin
export default {"historyTable":"Table_historyTable__KeagV"};